export const DATA_SOURCE_COUNT_LIMIT = 5;
export const PANEL_STANDARD_WIDTH = 532;
export const PANEL_EXPANDED_WIDTH = 801;